import { render, staticRenderFns } from "./CardTicketMultiTrip.vue?vue&type=template&id=244211aa&scoped=true&"
import script from "./CardTicketMultiTrip.vue?vue&type=script&lang=js&"
export * from "./CardTicketMultiTrip.vue?vue&type=script&lang=js&"
import style0 from "./CardTicketMultiTrip.vue?vue&type=style&index=0&id=244211aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244211aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
